
import { Component } from '@angular/core';

@Component({
  selector: 'student.page',
  template: '<router-outlet></router-outlet>'
})
export class StudentComponent { }
